import React, { useEffect, useState } from "react";
import "./style.scss";
import LayoutProvider from "../../../../providers/LayoutProvider";
import cardImage from "../../../../assets/images/training/instructor-card-image.png";
import { FaCircleInfo } from "react-icons/fa6";
import { FiPlus, FiX } from "react-icons/fi";
import InstructorCard from "../../../../components/Training/Instructor/InstructorCard";
import AddStudentModal from "./AddStudentModal";
import bgImage from "../../../../assets/images/training/student-card-main.png";
import useCustomToast from "../../../../hooks/useCustomToast";
import { validateEmail } from "../../../../helpers";
import InvitationService from "../../../../services/invitation.service";
import InstructorStudentCard from "../../../../components/Training/common/InstructorStudentCard";
import { useSelector } from "react-redux";
import { getStudentInstructorsTotalCount, getStudents, getStudentsFromApi, getUserApiStatus, setStudentsList } from "../../../../store/slices/instructor-student.slice";
import { useAppDispatch } from "../../../../hooks/app";
import { Toaster } from "react-hot-toast";
import SpinnerLoader from "../../../../components/SpinnerLoader";
import { API_STATUS } from "../../../../constants";
import { Link } from "react-router-dom";
import InstructorPagesProvider from "../../../../providers/InstructorPagesProvider";
import InfiniteScroll from "react-infinite-scroll-component";

type Anchor = "right";

function Instructor() {

  const students = useSelector(getStudents)
  const loading = useSelector(getUserApiStatus)
  const totalPages = useSelector(getStudentInstructorsTotalCount)
  const [perPage, setPerPage] = useState(30)
  const [page, setPage] = useState(1)
  const [query, setQuery] = useState('')

  const dispatch = useAppDispatch()
  const [inputs, setInputs] = React.useState({
    toEmail: "",
    name: "",
    expiration: ""
  })
  const customToast = useCustomToast()


  React.useEffect(() => {
    dispatch(setStudentsList([]))
  }, [])

  React.useEffect(() => {
    dispatch(getStudentsFromApi({ page, per_page: perPage, query }))
  }, [dispatch, perPage, page])

  const [state, setState] = React.useState({
    right: false,
  });


  const handleInput = (e: any) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const sendInvitationToUser = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!inputs?.toEmail) return customToast("Please enter email", "error")
    if (!validateEmail(inputs.toEmail)) return customToast("Please enter a valid email", "error")

    const res: any = await InvitationService.sendInvitation({ toEmail: inputs.toEmail, toName: inputs.name })
    if (res?.status === 201) {
      customToast(res?.message, "success")
    }
  }

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === "keydown" &&
          ((event as React.KeyboardEvent).key === "Tab" ||
            (event as React.KeyboardEvent).key === "Shift")
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };



  return (
    <InstructorPagesProvider>
      <LayoutProvider classNames="students_page">
        <Toaster />
        {loading === API_STATUS.LOADING && <SpinnerLoader />}
        <AddStudentModal inputs={inputs} toggleDrawer={toggleDrawer} state={state} handleInput={handleInput} sendInvitation={sendInvitationToUser} />
        <h2 className="heading2">Your Students</h2>

        <InstructorStudentCard
          inputs={inputs}
          handleInput={handleInput}
          sendInvitation={sendInvitationToUser}
          data={{
            bgImage,
            title: "Add/Invite Student",
            formLabel: "Invite Your Student",
            text: `If you have a student and would like to track the endorsements you
          give to them, enter the student's email address below. <br />
          They will confirm that they know you.`,
            buttonText: "Add Student",
          }}
        />


        <div className="filters_row d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4">
          <div className="d-flex align-items-center gap-3">
            <h2 className="heading3">Students</h2>
            <Link to="/training/invitations">New Invitations</Link>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-3">
            <button className="button" onClick={toggleDrawer("right", true)}>
              <span>
                <FiPlus />
                <span>Add Student</span>
              </span>
            </button>
          </div>
        </div>

        {!students?.length ? <div className="alert alert-warning my-4 d-flex align-items-center justify-content-between  py-2">
          <div className="d-flex align-items-center gap-2 p-0 m-0">
            <FaCircleInfo />
            <div className="fw-semibold">You have no Student</div>
          </div>
          <div className="close_icon" role="button">
            <FiX />
          </div>
        </div> : null}

        <InfiniteScroll
          dataLength={students?.length}
          loader={loading}
          next={() => {
            setPage((prev) => prev + 1)
          }}
          hasMore={page < totalPages}
          style={{ overflowX: "hidden" }}
        >
          <div className="students mt-3">
            <div className="row">
              {students?.map((student: any, i: number) => (
                <InstructorCard cardImage={cardImage} student={student} data={student} key={i} />
              ))
              }
            </div>
          </div>
        </InfiniteScroll>



      </LayoutProvider>
    </InstructorPagesProvider>
  );
}

export default Instructor;
